import get from 'lodash.get';
import {
    VirtualizedTableItem,
    VirtualizedTableColumns
} from 'services/virtualizedTable/types';
// Selectors
import { selectDocumentsArray } from 'services/documents/selectors';
import { selectDocumentSetId } from 'services/documentSets/selectors';
import {
    selectPeopleKeyedById,
    selectPeopleKeyedByUserId
} from 'services/people/selectors';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    FIELD_TYPE_DATE,
    FIELD_TYPE_STRING
} from 'components/VirtualizedTable/constants';

const selectJobAssessmentsTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths()],
    (tableColumnWidths): VirtualizedTableColumns => {
        const columns: VirtualizedTableColumns = [
            {
                label: 'Date',
                value: 'date',
                width: 200,
                type: FIELD_TYPE_DATE,
                dateFormat: 'MMM d, h:mm a'
            },
            {
                label: 'Assignees',
                value: 'assignees',
                width: 400,
                type: FIELD_TYPE_STRING
            },
            {
                label: 'Created By',
                value: 'createdBy',
                width: 200,
                type: FIELD_TYPE_STRING
            }
        ];

        return columns.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

const selectJobAssessmentItems = createDeepEqualSelector(
    [
        selectDocumentSetId,
        selectDocumentsArray,
        selectPeopleKeyedById,
        selectPeopleKeyedByUserId
    ],
    (documentSetId, documents, peopleKeyedById, peopleKeyedByUserId) =>
        documents
            .filter((document) => document.documentSetId === documentSetId)
            .map(
                ({
                    uuid,
                    submittedAt,
                    personIds,
                    createdByUserId
                }): VirtualizedTableItem => {
                    const assignees = personIds
                        .map(
                            (personId) =>
                                peopleKeyedById[personId] &&
                                peopleKeyedById[personId].fullName
                        )
                        .sort()
                        .join(', ');

                    const createdBy =
                        createdByUserId &&
                        peopleKeyedByUserId[createdByUserId].fullName;

                    return {
                        key: uuid,
                        date: submittedAt,
                        assignees,
                        createdBy
                    };
                }
            )
);

const makeSelectJobAssessmentItems = (): typeof selectJobAssessmentItems =>
    selectJobAssessmentItems;

export { selectJobAssessmentsTableColumns, makeSelectJobAssessmentItems };
